/* eslint-disable func-names */
const cookieTwoClick = () => {

	function createCookie(name, value, days) {
		let expires = "";
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = `; expires=${date.toGMTString()}`;
		}
    document.cookie = `${name}=${value}${expires}; path=/; Secure; sameSite=strict`;
	}

	function readCookie(name) {
		const nameEQ = `${name}=`;
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	let cookieData = readCookie('externalSources');
	if (!cookieData) {
		cookieData = '';
	}

	$('.cookie_2click').click(function () {
		const cookieType = $(this).attr('data-cookie');
		const cookieDataTemp = cookieData.split(',');

		let allowedByCookie = false;
		if ($('body').hasClass('is-IE')) {
			if (cookieDataTemp.indexOf(cookieType) > 0) {
				allowedByCookie = true;
			} else {
				allowedByCookie = false;
			}
		} else {
			allowedByCookie = cookieDataTemp.includes(cookieType)
		}

		if (!allowedByCookie) {
			cookieDataTemp.push(cookieType);
		}

		createCookie("externalSources", cookieDataTemp.join(','), 10);
	})

	$('body').on('click', '.cookie_2click_revoke', function () {
		const cookieType = $(this).attr('data-cookie');
		const cookieDataTemp = [];

		$(readCookie('externalSources').split(',')).each(function (i, obj) {
			if (obj !== cookieType) {
				cookieDataTemp.push(obj);
			}
		})

		createCookie("externalSources", cookieDataTemp.join(','), 10);

		setTimeout(function () {
			window.location.reload();
		}, 300);
	})

	$('.cookie2clickElementReplacement').each(function (i, obj) {
		const cookieType = $(this).attr('data-cookie-type');
		const cookieDataTemp = cookieData.split(',');

		let allowedByCookie = false;
		if ($('body').hasClass('is-IE')) {
			if (cookieDataTemp.indexOf(cookieType) > 0) {
				allowedByCookie = true;
			} else {
				allowedByCookie = false;
			}
		} else {
			allowedByCookie = cookieDataTemp.includes(cookieType);
		}



		if (allowedByCookie) {
			$(this).toggle(false);
			$(this).closest('section').find('.cookie2clickElement').toggleClass('is_hidden', false);
		} else {
			$(this).closest('section').find('.cookie2clickElement').toggleClass('is_hidden', true);
		}
	})

	$('body').on('click', '.cookie2clickElementReplacement .cookie_2click', function () {
		const parent = $(this).closest('.cookie2clickElementReplacement');
		if (parent.length > 0) {
			$(`.cookie2clickElementReplacement[data-cookie-type="${parent.attr('data-cookie-type')}"]`).each(function () {
				$(this).fadeOut(300);
				const element = $(this).closest('.section').find('.cookie2clickElement');
				setTimeout(function () {
					element.removeClass('is_hidden');
				}, 300)
			})
		}
	})

}

export default cookieTwoClick;
